import React, { useMemo } from 'react';
import { translate } from '../../Services/translation';
import QuickSearchNoHit from './QuickSearch.NoHit';
import QuickSearchResultTab from './QuickSearchResultTab';
import styled from 'styled-components';
import { breakpoint } from '../../styling/mixins/breakpoints';
import { getColor } from '../../styling/mixins/colors';
import { QuickSearchResultItem } from '../../Types/QuickSearchResultItem';
import { EditorStringModel } from '../../Types/EditorString';
import { fontFamilyBold } from '../../styling/mixins/typography';

interface QuickSearchWrapperProps {
  results: number;
}
const Wrapper = styled.div<QuickSearchWrapperProps>`
  position: absolute;
  top: 4rem;
  left: 0;
  right: 0;
  padding: 0 1.6rem;
  background-color: ${getColor('white')};
  height: 100vh;
  z-index: 62;
  ${breakpoint('large')} {
    border: 1px solid ${getColor('grey', 300)};
    top: 4.5rem;
    width: 800px;
    height: ${(props) => (props.results > 0 ? '380px' : 'auto')};
    border-radius: 4px;
    left: 50%;
    transform: translate(-50%, 0);
  }
  .tabs-navigation {
    display: flex;
    list-style-type: none;
    gap: 1.6rem;
    padding-top: 2.4rem;
    overflow-y: auto;
    margin-right: -1.6rem;
    padding-right: 1.6rem;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .button-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: fixed;
    height: 64px;
    bottom: 0;
    padding: 0.8rem 1.6rem;
    left: -1.6rem;
    margin-left: 1.6rem;
    border-top: 1px solid ${getColor('grey', 300)};
    background-color: ${getColor('white', 500)};
    ${breakpoint('large')} {
      position: absolute;
      bottom: 0;
      left: 0;
      margin-left: 0;
    }
  }
  .button {
    color: ${getColor('white')};
    background-color: ${getColor('gray', 900)};
    ${fontFamilyBold};
    text-align: center;
    line-height: 150%;
    flex: 1;
    padding: 1.2rem;
    border-radius: 0.4rem;
  }
`;

interface QuickSearchResultProps {
  result: { searchResult: QuickSearchResultItem };
  searchUrl: string;
  noHitHeader: string;
  noHitDescription: EditorStringModel;
}

const QuickSearchResult = ({
  result,
  searchUrl,
  noHitHeader,
  noHitDescription,
}: QuickSearchResultProps) => {
  const item = useMemo(() => result?.searchResult, [result]);

  const totalNumResults = useMemo(
    () => item?.items?.length ?? 0,
    [item]
  );
  return (
    <Wrapper results={totalNumResults}>
      <div>
        {totalNumResults > 0 &&
          item?.items?.length > 0 && (
            <QuickSearchResultTab
              modelKey={item.key}
              results={item.items}
            />
          )
        }
      </div>
      {totalNumResults == 0 && (
        <QuickSearchNoHit title={noHitHeader} description={noHitDescription} />
      )}
      {totalNumResults > 0 && (
        <div className="button-wrapper">
          {/* <div className="flex-1 d-flex align-center justify-center"> */}
          <a
            href={searchUrl}
            className="button btn btn--primary btn--large flex-1"
          >
            {translate('quicksearch.showmore')}
          </a>
        </div>
      )}
    </Wrapper>
  );
};

export default QuickSearchResult;
